var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.lines),function(line,i){return _c('div',{key:i},[(line)?_c('span',[_vm._v(_vm._s(line))]):_c('br')])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }